/**
 * Portuguese Dashboard Content - UI strings for Portuguese dashboard at /pt/dashboard
 * This file contains all translatable strings for the dashboard interface.
 */
window.PortugueseDashboardContent = {
    // ==========================================
    // HEADER & NAVIGATION
    // ==========================================
    header: {
        dashboard: "Painel",
        responses: "Respostas",
        myForms: "Meus Formulários",
        signOut: "Sair",
        upgrade: "Fazer upgrade",
        free: "Grátis",
        basic: "Evento Pro",
        premium: "Signature",
        viewOnly: "Somente Leitura"
    },

    // ==========================================
    // TAB NAVIGATION
    // ==========================================
    tabs: {
        responses: "Respostas",
        analytics: "Estatísticas",
        campaigns: "Mensagens para Convidados",
        export: "Exportar"
    },

    // ==========================================
    // RESPONSES TAB
    // ==========================================
    responses: {
        title: "Respostas",
        totalResponses: "Total de Respostas",
        attending: "Confirmados",
        notAttending: "Não Irão",
        maybe: "Talvez",
        adults: "Adultos",
        children: "Crianças",
        searchPlaceholder: "Buscar por nome, email ou telefone...",
        filterAll: "Todas as Respostas",
        filterYes: "Sim - Confirmados",
        filterNo: "Não - Não Irão",
        filterMaybe: "Talvez",
        noResponses: "Nenhuma resposta ainda",
        noResponsesDesc: "As respostas aparecerão aqui quando os convidados confirmarem presença.",
        shareFirstDesc: "Compartilhe o link com seus convidados. As respostas deles aparecem aqui.",
        sendInvitations: "Enviar convites",
        copyLink: "Copiar link",
        generalLink: "Link geral",
        personalLinks: "Links pessoais",
        loading: "Carregando respostas...",
        deleteConfirm: "Tem certeza que deseja excluir esta resposta?",
        deleteSuccess: "Resposta excluída com sucesso",
        saveSuccess: "Alterações salvas com sucesso",
        saveError: "Erro ao salvar alterações"
    },

    // ==========================================
    // TABLE HEADERS
    // ==========================================
    table: {
        name: "Nome",
        email: "Email",
        phone: "Telefone",
        attending: "Presença",
        guestCount: "Convidados",
        dietary: "Dieta",
        relationship: "Relacionamento",
        message: "Mensagem",
        submittedAt: "Data de Envio",
        actions: "Ações",
        yes: "Sim",
        no: "Não",
        maybe: "Talvez"
    },

    // ==========================================
    // ANALYTICS TAB
    // ==========================================
    analytics: {
        title: "Estatísticas do Evento",
        responseRate: "Taxa de Resposta",
        totalInvited: "Total Convidados",
        totalResponded: "Total Respondidos",
        pending: "Pendentes",
        attendanceBreakdown: "Detalhamento de Presença",
        guestBreakdown: "Detalhamento de Convidados",
        responseTimeline: "Linha do Tempo de Respostas",
        dietaryPreferences: "Preferências Alimentares",
        relationships: "Relacionamentos",
        setupTracking: "Configurar Rastreamento",
        setupTrackingDesc: "Insira o número de convites enviados para ver as estatísticas de taxa de resposta.",
        invitationsSent: "Convites Enviados",
        manualCount: "Contagem Manual",
        autoDetection: "Detecção Automática",
        switchToAuto: "Mudar para detecção automática?",
        noAnalyticsYet: "Nenhuma estatística disponível ainda",
        noAnalyticsDesc: "As estatísticas aparecerão quando você receber respostas."
    },

    // ==========================================
    // CAMPAIGNS TAB
    // ==========================================
    campaigns: {
        title: "Mensagens para Convidados",
        newCampaign: "Enviar mensagens",
        sendInvitations: "Enviar Convites",
        campaignHistory: "Histórico de Mensagens",
        noCampaigns: "Pronto para convidar?",
        noCampaignsDesc: "Envie convites personalizados por email ou WhatsApp. Rastreamos quem abre e responde.",
        createFirst: "Enviar Convites",
        contactStatus: "Status de Contatos",
        sendReminder: "Enviar Lembrete",
        scheduledReminders: "Lembretes Agendados",
        credits: "Créditos",
        buyCredits: "Comprar Créditos",
        messagesSent: "mensagens enviadas",
        delivered: "entregues",
        opened: "abertos",
        clicked: "cliques",
        responded: "responderam",
        pending: "pendentes"
    },

    // ==========================================
    // CAMPAIGN WIZARD
    // ==========================================
    wizard: {
        title: "Enviar Convites",
        step1: "Contatos",
        step2: "Revisar",
        step3: "Enviar",
        addContacts: "Adicionar Contatos",
        importFromFile: "Importar de Arquivo",
        pasteContacts: "Colar Contatos",
        manualEntry: "Entrada Manual",
        uploadCSV: "Enviar CSV",
        uploadVCard: "Enviar vCard",
        dragDropHere: "Arraste arquivos aqui ou clique para buscar",
        supportedFormats: "Formatos suportados: CSV, VCF (vCard)",
        contactsAdded: "contatos adicionados",
        reviewContacts: "Revisar Contatos",
        removeSelected: "Remover Selecionados",
        selectAll: "Selecionar Todos",
        deselectAll: "Desmarcar Todos",
        messageTemplate: "Modelo de Mensagem",
        personalizeMessage: "Personalizar Mensagem",
        previewMessage: "Prévia da Mensagem",
        sendVia: "Enviar por",
        email: "Email",
        whatsapp: "WhatsApp",
        both: "Ambos",
        schedule: "Agendar",
        sendNow: "Enviar Agora",
        scheduleLater: "Agendar para Depois",
        confirmSend: "Confirmar Envio",
        sending: "Enviando...",
        sent: "Enviado",
        failed: "Erro",
        cancel: "Cancelar",
        back: "Voltar",
        next: "Próximo",
        finish: "Finalizar"
    },

    // ==========================================
    // EXPORT TAB
    // ==========================================
    export: {
        title: "Exportar Dados",
        exportCSV: "Exportar para CSV",
        exportLanguage: "Idioma de Exportação",
        original: "Original (Sem tradução)",
        selectLanguage: "Selecionar idioma...",
        exportAll: "Exportar Tudo",
        exportFiltered: "Exportar Filtrado",
        downloading: "Baixando...",
        downloadComplete: "Download completo",
        noDataToExport: "Sem dados para exportar"
    },

    // ==========================================
    // MODALS
    // ==========================================
    modals: {
        editResponse: "Editar Resposta",
        deleteResponse: "Excluir convidado",
        confirmDelete: "Tem certeza que deseja excluir esta resposta? Esta ação não pode ser desfeita.",
        sendReminder: "Enviar Lembrete Inteligente",
        reminderDesc: "Os destinatários são filtrados com base no rastreamento de mensagens.",
        recipients: "Destinatários",
        customMessage: "Mensagem Personalizada (opcional)",
        customMessagePlaceholder: "Adicione uma nota pessoal...",
        scheduledReminders: "Configurar Lembretes Agendados",
        enableReminders: "Habilitar Lembretes Agendados",
        reminderTiming: "Quando enviar lembretes:",
        oneDay: "1 dia antes",
        threeDays: "3 dias antes",
        oneWeek: "1 semana antes",
        twoWeeks: "2 semanas antes",
        contactStatus: "Status de Contatos",
        allContacts: "Todos os Contatos",
        respondedFilter: "Responderam",
        pendingFilter: "Pendente",
        doubleResponse: "Resposta Dupla ⚠️",
        emailStatus: "Status do Email",
        whatsappStatus: "Status do WhatsApp",
        translating: "Traduzindo Respostas",
        translatingTo: "Traduzindo respostas para"
    },

    // ==========================================
    // USER EVENTS
    // ==========================================
    events: {
        myEvents: "Meus Eventos",
        noEvents: "Nenhum Evento Encontrado",
        noEventsDesc: "Você ainda não criou nenhum formulário RSVP.",
        createFirst: "Criar Seu Primeiro Evento",
        created: "Criado",
        eventId: "ID do Evento",
        viewResponses: "Ver Respostas",
        loadingEvents: "Carregando seus eventos...",
        errorLoading: "Erro ao carregar eventos"
    },

    // ==========================================
    // AUTH
    // ==========================================
    auth: {
        signIn: "Entrar",
        signInDesc: "Entre para ver seus formulários",
        signInPrompt: "Entre para acessar",
        loginWithEmail: "Entrar com Email",
        loginWithGoogle: "Continuar com Google",
        loginWithApple: "Continuar com Apple",
        or: "ou",
        noAccount: "Não tem conta?",
        createAccount: "Criar conta"
    },

    // ==========================================
    // COMMON
    // ==========================================
    common: {
        loading: "Carregando...",
        save: "Salvar",
        cancel: "Cancelar",
        close: "Fechar",
        delete: "Excluir",
        edit: "Editar",
        confirm: "Confirmar",
        send: "Enviar",
        search: "Buscar",
        filter: "Filtrar",
        refresh: "Atualizar",
        backToEvents: "Voltar para Meus Eventos",
        backToAccess: "Voltar para Opções de Acesso",
        selectEvent: "Selecionar Evento",
        selectEventDesc: "Por favor selecione um evento específico no menu acima.",
        error: "Erro",
        success: "Sucesso",
        warning: "Aviso",
        info: "Informação",
        guests: "convidados"
    },

    // ==========================================
    // UPGRADE PROMPTS
    // ==========================================
    upgrade: {
        unlockResponses: "Desbloquear Todas as Respostas",
        freeLimit: "Você pode ver até 25 respostas.",
        upgradeForUnlimited: "Melhore o plano para visualização ilimitada →",
        upgradeRequired: "Upgrade necessário"
    },

    // ==========================================
    // ANALYTICS INSIGHTS (Dynamic JS Content)
    // ==========================================
    insights: {
        // Pattern Insights
        peakResponseDay: "Dia com Mais Respostas",
        peakResponseTime: "Horário com Mais Respostas",
        responseMomentum: "Ímpeto de Respostas",
        attendanceRate: "Taxa de Presença",
        daysUntilEvent: "Dias Até o Evento",
        eventDay: "Dia do Evento",

        // Velocity labels
        pickingUp: "Aumentando",
        slowingDown: "Diminuindo",
        steadyPace: "Ritmo Constante",
        responsesComing: "Respostas chegando mais rápido recentemente",
        responseDecreased: "A taxa de respostas diminuiu",
        consistentRate: "Taxa de respostas consistente",

        // Smart Insights
        excellentResponseRate: "Excelente Taxa de Resposta",
        lowResponseRate: "Baixa Taxa de Resposta",
        highGuestMultiplier: "Alto Multiplicador de Convidados",
        lowerGuestImpact: "Menor Impacto de Convidados",
        attendanceConcerns: "Preocupações com Presença",
        strongAttendance: "Forte Compromisso de Presença",

        // Insight descriptions
        respondedWellAbove: "dos convidados responderam - bem acima da média!",
        onlyResponded: "Apenas responderam. Considere enviar lembretes.",
        guestImpact: "de impacto de convidados - as pessoas estão trazendo acompanhantes!",
        ensureVenue: "Garanta que o local e buffet comportem a quantidade maior.",
        fewerPlusOnes: "impacto de convidados sugere menos acompanhantes que o esperado.",
        encourageCompanions: "Considere incentivar convidados a trazer acompanhantes.",
        respondentsAttending: "dos respondentes irão comparecer.",
        investigateBarriers: "Investigue possíveis conflitos ou problemas com a data/local.",
        showsStrongInterest: "da taxa de presença mostra forte interesse no seu evento!",

        // Activity insights
        greatMomentum: "Ótimo Ímpeto!",
        activeResponses: "Respostas Ativas",
        recentActivity: "Atividade Recente",
        responsesThisWeek: "respostas esta semana com ritmo acelerado",
        responsesLast7Days: "respostas nos últimos 7 dias - bom engajamento",
        responseInLast: "resposta(s) nos últimos 7 dias",

        // Prediction
        expectedFinalAttendance: "Presença Final Esperada",
        projecting: "Projetando",
        totalGuests: "convidados totais baseado nas tendências atuais",
        highConfidence: "alta confiança",
        moderateConfidence: "confiança moderada",
        earlyEstimate: "estimativa inicial",
        getMoreResponses: "Obtenha mais respostas para melhorar a precisão",

        // Event countdown
        finalCountdown: "Contagem regressiva final!",
        comingSoon: "Em breve",
        timeToPrepare: "Hora de preparar",
        daysRemaining: "dia(s) restante(s)",
        eventIsToday: "Seu evento é hoje!",

        // Additional insights
        highResponseVelocity: "Alta Velocidade de Resposta",
        responsesLast24h: "respostas nas últimas 24h sugerem forte engajamento",
        optimalCommunicationDay: "Melhor Dia para Comunicação",
        showsResponses: "mostra",
        ofResponses: "das respostas - ideal para acompanhamento",
        scheduleRemindersOn: "Agende lembretes futuros para máxima taxa de resposta",
        slowResponseCollection: "Coleta Lenta de Respostas",
        averagingResponses: "Média de",
        responsesPerDay: "respostas por dia em",
        days: "dias",
        considerDeadline: "Considere mensagens de urgência para acelerar respostas",
        timeForFollowUp: "Hora de Acompanhamento",
        noResponsesIn: "Sem respostas em",
        reminderCouldBoost: "dias - um lembrete pode aumentar o engajamento",

        // Engagement insights
        highDetailEngagement: "Alto Engajamento nos Detalhes",
        providedDietary: "forneceram informações de dieta - convidados muito engajados",
        groupEventPattern: "Padrão de Evento em Grupo",
        bringingPeople: "Convidados trazem",
        peopleOnAverage: "pessoas em média - planeje para grupos",
        ensureSeating: "Garanta assentos e buffet para grupos",
        lowFieldCompletion: "Baixo Preenchimento de Campos",
        hasLowCompletion: "tem baixo preenchimento",
        haveLowCompletion: "têm baixo preenchimento",
        considerRequired: "Considere tornar campos chave obrigatórios",

        // Final week
        finalWeekPush: "Esforço Final Necessário",
        eventIn: "Evento em",
        daysWithOnly: "dias com apenas",
        responseRateLabel: "taxa de resposta",
        attendanceRateLabel: "taxa de presença",
        sendUrgentReminder: "Envie lembrete urgente final para maximizar confirmações",
        finalPlanningWindow: "Janela Final de Planejamento",
        daysLeft: "dias restantes - hora da contagem final e logística",
        finalizeCatering: "Finalize quantidades do buffet e envie detalhes aos confirmados",

        // Chart Labels
        adults: "Adultos",
        children: "Crianças",
        guests: "Convidados",
        dietary: "Requisitos Alimentares",
        relationship: "Relacionamento",
        attending: "Confirmados",
        maybe: "Talvez",
        notAttending: "Não Irão",
        noResponse: "Sem Resposta",

        // Activity
        someone: "Alguém",
        confirmedAttendance: "confirmou presença",
        declined: "recusou",
        fromBulk: "de massa",
        manual: "manual",
        fromBulkMessaging: "de mensagens em massa",
        clickToAdjust: "Clique para ajustar",
        sendBulkToUnlock: "Envie mensagens para desbloquear esta métrica",
        guestsConfirmed: "convidados confirmados de",
        invitations: "convites",
        day: "dia",
        untilEvent: "até o evento",

        // Saturation
        responseSaturation: "Saturação de Respostas Atingida",
        patternSuggests: "O padrão sugere que você capturou a maioria das respostas disponíveis",

        // Live Activity
        liveUpdates: "Atualizações ao Vivo",
        live: "Ao Vivo",
        reached: "Alcançou",
        responses: "respostas!",
        latest: "Recente",

        // Day names
        sunday: "Domingo",
        monday: "Segunda",
        tuesday: "Terça",
        wednesday: "Quarta",
        thursday: "Quinta",
        friday: "Sexta",
        saturday: "Sábado",

        // Time ranges
        morning: "Manhã (6h-12h)",
        afternoon: "Tarde (12h-18h)",
        evening: "Noite (18h-22h)",
        night: "Madrugada (22h-6h)",

        // Yes/No/Maybe
        yes: "sim",
        no: "não",
        maybe: "talvez",

        // Smart insights empty state
        smartInsightsWillAppear: "Insights inteligentes aparecerão quando chegarem mais respostas..."
    },

    // ==========================================
    // BULK SHARING WIZARD (Full UI)
    // ==========================================
    bulkWizard: {
        // Builder-mount success screen (first send from the Share step).
        remindersOnDashboard: "Lembretes, status de entrega e acompanhamentos estão no seu painel.",
        goToDashboard: "Abrir painel",
        outcomeScheduledTitle: "Mensagem agendada",
        outcomeScheduledBody: "Sua mensagem será enviada em {date}.",
        outcomeApprovalTitle: "Aguardando aprovação do WhatsApp",
        outcomeApprovalBody: "O WhatsApp verifica cada mensagem nova antes de enviá-la, normalmente em poucos minutos. Seus convidados do WhatsApp vão recebê-la assim que for aprovada, e você não precisa fazer mais nada.",
        outcomeApprovalOthersSent: "Os convidados que recebem por e-mail ou SMS já estão recebendo a mensagem.",
        outcomeHeldTitle: "Sua primeira mensagem está em análise",
        outcomeHeldBody: "É uma verificação única no primeiro envio. Enviaremos um e-mail para você assim que ela for liberada. Nada foi enviado e nenhum crédito foi usado.",
        outcomeRefusedTitle: "O WhatsApp não aceitou esta mensagem",
        outcomeRefusedReason: "Motivo indicado pelo WhatsApp: {reason}",
        outcomeRefusedOthersNow: "Os convidados que recebem por e-mail ou SMS continuam recebendo a mensagem.",
        outcomeRefusedOthersScheduled: "Os convidados que recebem por e-mail ou SMS vão recebê-la normalmente em {date}.",
        outcomeRefusedNoOthers: "Ainda não foi enviada para nenhum dos seus convidados.",
        outcomeRefusedFix: "Para chegar aos seus convidados do WhatsApp, edite a mensagem no seu painel e envie novamente. O WhatsApp vai verificar o novo texto.",
        tplErr_trailingParam: "Sua mensagem não pode TERMINAR com uma etiqueta de personalização como {{name}} ou {{table_number}}. O WhatsApp não permite isso. Coloque uma palavra ou um ponto final depois da etiqueta e envie novamente.",
        tplErr_waLink: "O WhatsApp não permite um botão com link de volta para o WhatsApp. Aponte esse botão para outro lugar e envie novamente.",
        tplErr_imageFormat: "Para o WhatsApp, a imagem do seu convite precisa ser JPG ou PNG. Faça o upload dela de novo nesse formato e envie novamente.",
        tplErr_imageProcess: "O WhatsApp não conseguiu processar a imagem do seu convite. Tente outra (JPG ou PNG, com menos de 5 MB) e envie novamente.",
        tplErr_category: "O WhatsApp considera que sua mensagem é de um tipo diferente daquele em que a registramos. Envie novamente e ela deve passar.",
        tplErr_layout: "O WhatsApp não conseguiu ler o formato da sua mensagem. Normalmente é uma {{etiqueta}} sozinha em uma linha. Coloque-a dentro de uma frase e envie novamente.",
        tplErr_duplicateName: "O WhatsApp já tem uma mensagem salva com este nome. Mude o nome da mensagem e envie novamente.",
        tplErr_rateLimit: "Você atingiu o limite de mensagens novas do WhatsApp por enquanto. Aguarde um pouco e envie novamente. Nada será perdido.",
        outcomeSubmitFailedTitle: "Ainda não conseguimos enviar sua mensagem para aprovação do WhatsApp",
        close: "Fechar",
        outcomeSubmitFailedBody: "Vamos continuar tentando automaticamente e enviaremos um e-mail para você se o WhatsApp recusar a mensagem. Por enquanto, você não precisa fazer nada.",
        outcomeVerifyTitle: "Confirme seu e-mail para enviá-la",
        outcomeVerifyBody: "Sua mensagem está salva, mas nada foi enviado ainda. Confirme seu endereço de e-mail (na aba Compartilhar do seu formulário) e ela será enviada automaticamente.",
        outcomeUpgradeTitle: "É necessário atualizar o plano antes do envio",
        outcomeUpgradeBody: "Este evento usa recursos do modelo que exigem a atualização do plano. Atualize o plano no painel do evento e sua mensagem será enviada automaticamente. Nada foi enviado ainda.",
        outcomePausedTitle: "Sua mensagem ainda não foi enviada",
        outcomePausedBody: "Ela está salva, mas nada foi enviado ainda. Você pode ver o status no seu painel.",
        sendBlockedBlanks: "Sua mensagem ainda tem campos do modelo para preencher: {blanks}",
        sendDateMissing: "Escolha uma data para sua mensagem agendada.",
        sendDatePast: "A data e a hora agendadas já passaram. Escolha um momento futuro.",
        // Initial loading
        checkingAccess: "Verificando permissões de acesso...",
        wizardFailedToLoad: "O assistente de mensagens não pôde ser carregado. Por favor, atualize a página.",

        // Progress steps
        step1Contacts: "1. Contatos",
        step2Channels: "2. Canais",
        step2Review: "3. Personalizar",
        step3FollowUp: "4. Acompanhamento",
        step4Send: "5. Enviar",

        // Navigation buttons
        previous: "Anterior",
        next: "Próximo",
        nextChannels: "Próximo: Canais de envio",
        nextCustomize: "Próximo: Personalizar",
        nextFinalize: "Próximo: Finalizar e Enviar",
        skip: "Pular",
        saveAsDraft: "Salvar como Rascunho",

        // Contacts step
        uploadContactList: "Enviar Lista de Contatos",
        uploadContactsDesc: "Envie contatos em formato CSV ou vCard",
        dragDropFile: "Arraste e solte o arquivo aqui",
        orClickToBrowse: "ou clique para procurar",
        chooseFile: "Escolher Arquivo",
        csvOrVcard: "CSV ou vCard (.vcf)",
        manuallyAddContacts: "Adicionar Contatos Manualmente",
        csvTemplate: "Modelo CSV",
        vcardTemplate: "Modelo vCard",

        // Phone tip
        phoneTip: "Os números de telefone devem incluir o código do país (ex: +5511999999999). Se usar o Excel, formate a coluna como 'Texto' para evitar problemas de formatação.",

        // Sending method
        sendVia: "Enviar via",
        channelEmail: "E-mail",
        channelEmailTooltip: "Enviar por e-mail. Se não houver e-mail, o celular será usado.",
        channelMobile: "Celular (WhatsApp/SMS)",
        channelMobileTooltip: "Enviar por WhatsApp, com SMS como fallback. Se não houver telefone, o e-mail será usado.",
        channelHint: "1 crédito por canal. O sistema alterna para outros canais se a entrega falhar.",
        deliveryMethod: "Método de envio",
        smartDeliveryLabel: "Envio inteligente",
        smartDeliveryShortDesc: "WhatsApp/SMS quando disponível, e-mail caso contrário.",
        smartDeliveryCreditNote: "1 crédito por contato.",
        customizeDelivery: "Personalizar",
        channelsStepTitle: "Revise os canais de envio",
        channelsStepSubtitle: "Escolha como seus convidados receberão este convite.",
        usNumbersDeliveryNote: "🇺🇸 Aviso sobre números dos EUA: a Meta não permite o envio em massa de WhatsApp para números dos EUA, portanto eles serão enviados automaticamente por SMS padrão. Números canadenses também começam com +1, mas não são afetados: recebem WhatsApp. Se os seus convidados com números dos EUA estiverem atualmente no exterior, recomendamos muito adicionar um endereço de e-mail para garantir a entrega.",
        deliveryModalTitle: "Como devemos entregar?",
        deliveryOptionSmart: "Envio inteligente",
        deliveryOptionSmartTag: "Recomendado",
        deliveryOptionSmartDesc: "WhatsApp para contatos fora dos EUA, SMS para contatos nos EUA, e e-mail para contatos sem telefone. 1 crédito por contato.",
        deliveryOptionEmail: "E-mail primeiro",
        deliveryOptionEmailDesc: "Prioriza o envio por e-mail. Usa o celular automaticamente se nenhum e-mail for fornecido.",
        deliveryOptionMobile: "Celular primeiro",
        deliveryOptionMobileDesc: "Prioriza o envio por celular (WhatsApp/SMS). Usa o e-mail automaticamente se nenhum número de telefone for fornecido.",
        deliveryOptionBoth: "Ambos os canais",
        deliveryOptionBothDesc: "Enviar por e-mail e celular quando ambos estiverem disponíveis.",
        deliveryOptionBothCost: "1 crédito por contato, mesmo com os dois canais.",
        deliveryDoneBtn: "Salvar",
        deliveryCancelBtn: "Cancelar",
        usWhatsappShortNotice: "WhatsApp em massa não é permitido para números dos EUA (política da Meta).",

        // SMS consent
        consentNotice: "Seus convidados podem ter taxas de mensagens e dados (a frequência varia) e podem responder STOP para cancelar, HELP para ajuda.",
        usWhatsappNotice: "De acordo com a política atual da Meta, números de telefone dos EUA não podem receber mensagens em massa do WhatsApp e serão automaticamente redirecionados para SMS. Você ainda pode enviar mensagens para números dos EUA individualmente pelo WhatsApp.",
        smsConsentCheckbox: "Confirmo que todos os destinatários consentiram em receber mensagens SMS de convite para meu evento via QuikRSVP.",
        smsConsentDisclosure: "Os destinatários podem responder STOP para cancelar ou HELP para assistência. Taxas de dados e mensagens podem ser aplicadas. A frequência varia.",
        smsConsentRequired: "Você deve confirmar o consentimento dos destinatários antes de enviar.",
        termsConsentRequired: "Você precisa aceitar os Termos e Condições e a Política de Privacidade antes de enviar.",
        smsConsentEmailFallbackHint: "Não há endereço de e-mail para {n} dos seus convidados, então a mensagem vai para o celular, possivelmente por SMS.",
        smsConsentEditTitle: "Confirmar o consentimento para SMS",
        smsConsentEditBody: "Alguns convidados desta mensagem têm números dos EUA, outros números +1 ou números do Brasil, então podem recebê-la por SMS. Confirme o consentimento deles para salvar as alterações.",
        smsConsentEditSave: "Confirmar e salvar",
        termsLink: "Termos e Condições",
        privacyLink: "Política de Privacidade",

        // Contact summary
        valid: "válidos",
        invalid: "inválidos",
        messages: "mensagens",
        editContacts: "Editar contatos",
        invalidContacts: "Contatos Inválidos:",

        // Follow-up banner
        followUpCampaign: "Mensagem de Acompanhamento",
        contactsAutoLoaded: "contatos foram carregados automaticamente da sua mensagem anterior.",
        filterApplied: "Filtro aplicado:",
        startFresh: "Começar do Zero",

        // File parsing
        dragDropCsv: "Arraste e solte o arquivo CSV aqui ou clique para procurar",
        dragDropVcard: "Arraste e solte o arquivo vCard aqui ou clique para procurar",
        csvColumns: "Colunas: Nome(s) dos convidados, Nome do grupo, Telefone, E-mail (opcionais: Máx. convidados, Etiquetas)",
        downloadCsvTemplate: "Baixar Modelo CSV",
        downloadVcardTemplate: "Baixar Modelo vCard",
        vcardFromSources: "Arquivo .vcf padrão de fontes como Google Contacts ou Outlook.",

        // Send step
        readyToSend: "Pronto para Enviar!",
        reviewAndSend: "Revise os detalhes da sua mensagem e envie seus convites.",
        campaignSummary: "Resumo da Mensagem",
        totalMessages: "Total de Mensagens",
        emailLabel: "E-mail",
        mobileLabel: "Celular",

        // Reminders
        remindersEnabled: "Lembretes Ativados:",

        // Credits
        messageCredits: "Créditos de Mensagens",
        yourBalance: "Seu Saldo",
        creditsNeeded: "Créditos Necessários",
        readyToSendCredits: "Pronto para enviar! Você tem créditos suficientes para esta mensagem.",
        needMoreCredits: "Você precisa de mais créditos.",
        purchasePackage: "Compre um pacote para continuar.",

        // Send timing
        sendTiming: "Agendamento de Envio",
        sendImmediately: "Enviar Imediatamente",
        messagesQueuedNow: "As mensagens serão colocadas na fila imediatamente",
        scheduleForLater: "Agendar para Mais Tarde",
        chooseDateTime: "Escolha uma data e hora específicas",
        date: "Data",
        time: "Hora",
        schedulingNote: "O horário de entrega é aproximado e não garantido. As mensagens serão colocadas na fila para processamento no horário agendado.",

        // Buttons
        sendCampaign: "Enviar aos convidados",
        upgradeAndBuyCredits: "Atualizar e Comprar Créditos",
        buyCredits: "Comprar Créditos",

        // Credits info
        creditsInfo: "Os créditos são contados por convidado, não por mensagem • Os créditos nunca expiram • Funcionam em todos os formulários",
        // Send step: guests per channel and the one cost line (_deliveryPlanHtml).
        deliveryPlanTitle: "Como seus convidados vão receber",
        deliveryWhatsapp: "WhatsApp",
        deliverySms: "Mensagem de texto (SMS)",
        deliveryEmail: "E-mail",
        deliveryGuestsOne: "1 convidado",
        deliveryGuestsMany: "{n} convidados",
        deliveryFullDesc: "Sua mensagem completa, com a imagem e os botões que você adicionou",
        deliverySmsDesc: "Só texto: sem imagem nem botões. Seus links vão como endereços web.",
        deliverySmsDescNoLink: "Só texto: sem imagem, botões nem links.",
        deliverySmsWhy: "Os números dos EUA recebem um SMS porque o WhatsApp não entrega convites deste tipo a números dos EUA.",
        deliverySmsPreview: "Ver o SMS que vão receber",
        deliverySmsCantSend: "Estes convidados não vão receber SMS: um SMS só pode levar letras latinas e esta mensagem não tem nenhuma. Adicione uma versão em inglês da sua mensagem na etapa Personalizar para chegar até eles.",
        deliverySmsEmailOnlyOne: "1 deles tem endereço de e-mail e vai receber apenas o e-mail.",
        deliverySmsEmailOnlyMany: "{n} deles têm endereço de e-mail e vão receber apenas o e-mail.",
        deliverySmsNothingOne: "1 convidado não vai receber nada.",
        deliverySmsNothingMany: "{n} convidados não vão receber nada.",
        costLabel: "Custo",
        costCreditsOne: "1 crédito",
        costCreditsMany: "{n} créditos",
        costPerGuest: "1 crédito por convidado",
        costPerGuestTicketed: "1 crédito por convidado contatado por celular; os e-mails são gratuitos em eventos com ingressos",
        balanceAfterSending: "Saldo depois do envio: {n}",
        costUnsentNote: "Os créditos reservados para os convidados que não recebem nada são devolvidos a você depois do envio.",
        remindersCostNote: "Cada lembrete custa 1 crédito por convidado que alcança, quando é enviado.",
        remindersCostNoteTicketed: "Cada lembrete custa 1 crédito por convidado que alcança por celular, quando é enviado. Os e-mails são gratuitos.",
        notEnoughCreditsToSend: "Créditos insuficientes: você tem {balance} e esta mensagem precisa de {needed}. Compre mais créditos e envie novamente.",

        // Contact editor modal
        contactEditor: "Editor de Contatos",
        name: "Nome",
        email: "E-mail",
        phone: "Telefone",
        actions: "Ações",
        addNewContact: "Adicionar Novo Contato",
        saveContacts: "Salvar Contatos",
        cancel: "Cancelar",

        // Validation
        contactsCleared: "Contatos limpos. Agora você pode enviar uma nova lista.",

        // Review step labels
        composeYourMessage: "Escreva sua Mensagem",
        composeSubtitle: "Personalize seu convite e escolha como os convidados o receberão.",
        messageAndTranslations: "Mensagem e traduções",
        customEmailSettings: "Configurações de e-mail",
        buttonsLinks: "Botões e Links",
        linksButtonsLabel: "Links / botões",
        buttonsLinksHint: "Escolha até 2 botões para incluir na sua mensagem.",
        campaignButtonsMax: "Você pode incluir até 2 botões por mensagem",
        buttonCaptionAlsoIn: "Também enviado em {n}",
        buttonCaptionAsTyped: "Seu texto — enviado exatamente assim",
        buttonCaptionPairTip: "Os dois idiomas vão juntos no botão. Se o par passar dos 25 caracteres que o WhatsApp permite, fica só um — veja a prévia para o texto exato.",
        buttonLabelOptional: "Texto do botão (opcional)",
        buttonAppearsOn: "Os botões aparecem no WhatsApp e no e-mail.",
        rsvpTargetLabel: "Para onde o link de confirmação deve apontar?",
        rsvpTargetForm: "Formulário QuikRSVP",
        rsvpTargetWebsite: "Meu site de casamento",
        campaignName: "Nome da mensagem",
        campaignNamePlaceholder: "Dê um nome à sua mensagem…",
            campaignNameDefaultDescriptor: "Convites",
        campaignNameHelp: "Dê um nome a esta mensagem para identificá-la depois",
        campaignNameDuplicate: "Já existe uma mensagem com este nome. Escolha um nome único (por exemplo, adicione “- Grupo B”), ou adicione contatos à sua mensagem existente.",
        campaignNameDupShort: "Já existe uma mensagem com este nome.",
        campaignNameDupViewExisting: "Ver mensagem existente",
        emailSubjectLine: "Assunto do E-mail",
        emailSenderName: "Nome do Remetente",
        emailSenderNameHelp: "Nome exibido aos convidados",
        replyToLabel: "As respostas vão para",
        replyToDefaultSuffix: "padrão",
        replyToAddOption: "Usar outro endereço…",
        replyToNewPlaceholder: "nome@exemplo.com",
        replyToSendVerify: "Enviar confirmação",
        replyToSending: "Enviando…",
        replyToSent: "Confirmação enviada. Abra essa caixa, clique no link e depois escolha o endereço aqui.",
        replyToRecheck: "Já confirmei",
        replyToAlreadyVerified: "Esse endereço já está confirmado — escolha-o na lista.",
        replyToInvalid: "Digite um endereço de e-mail válido.",
        replyToError: "Não foi possível enviar a confirmação. Tente novamente.",
        replyToWhyVerify: "Confirmamos o endereço primeiro para que os convites não possam encaminhar respostas para uma caixa que o remetente não controla.",
        emailThemeColor: "Cor do E-mail",
        emailLogo: "Logo do E-mail",
        emailLogoUpload: "Enviar",
        emailLogoHide: "Ocultar",
        emailLogoShow: "Mostrar",
        emailLogoReset: "Usar o logo do QuikRSVP",
        emailLogoPaidOnly: "Planos pagos",
        emailLogoUpgradeMsg: "O logo personalizado está disponível nos planos pagos — faça upgrade do seu formulário para personalizá-lo.",
        messageHeader: "Cabeçalho do Convite",
        messageHeaderHelp: "Título em negrito no topo do seu e-mail e WhatsApp. Apague para ocultar.",
        invitationTagline: "Legenda do Convite",
        invitationTaglineHelp: "Texto menor abaixo do cabeçalho (ex.: \"Você Está Convidado\"). Apague para ocultar. (apenas e-mail)",
        headerAndSubject: "Título, Legenda e Assunto",
        leaveBlankToHide: "Deixe em branco para ocultar",
        yourMessage: "Sua Mensagem",
        writeMessagePlaceholder: "Escreva sua mensagem de convite aqui...",
        characters: "caracteres",
        translateTo: "Traduzir para:",
        translate: "Traduzir",
        translationWillAppear: "A tradução aparecerá aqui...",
        // Message & Translations block (task #453)
        translateHint: "Envie este convite em outro idioma",
        translationsReady: "Traduções prontas",
        messageLanguages: "Idiomas da mensagem",
        yourMessageBadge: "Sua mensagem",
        hide: "Ocultar",
        view: "Ver",
        addAnotherLanguage: "Adicionar outro idioma",
        chooseLanguage: "Escolher…",
        willSendAsWritten: "Os convidados recebem {a} — a mensagem exatamente como você escreveu",
        willSendTranslationOnly: "Os convidados recebem apenas {a} — seu original não é enviado",
        willSendBoth: "Os convidados recebem {a} e {b} juntos em uma só mensagem",
        oneTranslationOnly: "Uma mensagem leva o seu original mais uma tradução. Desmarque {lang} primeiro.",
        pickAtLeastOneLanguage: "Escolha pelo menos um idioma para enviar.",
        addLanguageToTranslate: "Escolha um idioma para traduzir.",
        emptyLanguageBlocked: "Adicione texto para {langs} ou desmarque o idioma.",
        emptyLanguagesBlocked: "Adicione texto para estes idiomas ou desmarque-os: {langs}.",
        smsNotSendable: "não é possível enviar por SMS",
        smsSourceOnly: "O SMS envia apenas o seu original",
        smsSendsTranslation: "O SMS envia a sua tradução em vez disso",
        waCombinedOver: "Os dois idiomas compartilham uma só mensagem de WhatsApp — {n} de 1.024 caracteres. Encurte um deles.",
        bothWillBeSent: "Original e tradução serão enviados",
        onlyTranslationWillBeSent: "Apenas a tradução será enviada",
        sendAsWrittenDesc: "A mensagem já está no idioma dos convidados",
        sendTranslatedOnly: "Enviar apenas versão traduzida",
        bilingual: "Bilíngue",
        sendBilingual: "Enviar ambos (original e tradução) em uma mensagem",
        multiLanguageHint: "Precisa contatar convidados em idiomas diferentes separadamente? Crie uma mensagem para cada idioma.",
        preview: "Prévia",
        addImage: "Adicionar Imagem",
        changeImage: "Alterar Imagem",
        convertingImage: "Convertendo a foto do iPhone…",
        processingImage: "Processando a imagem…",
        uploadingImage: "Enviando…",
        invitationImage: "Imagem do Convite",
        invitationImageDesc: "Opcional — exibida no topo do seu e-mail e da mensagem de WhatsApp.",
        invitationSplashLabel: "Abrir em tela cheia ao tocar",
        invitationSplashDesc: "Os convidados que tocarem no seu convite no WhatsApp o veem em tamanho grande e, depois, seu formulário de confirmação.",
        beforeYouSend: "Antes de enviar",
        goodToKnow: "Notas sobre créditos e entrega",
        optionalLabel: "opcional",
        csvFormattingTips: "Dicas de formatação CSV",
        downloadTemplate: "Baixar modelo",
        previewShowsExactly: "A prévia mostra exatamente o que os convidados receberão.",

        // What happens next
        whatHappensNext: "O que acontece depois?",

        // Success states
        campaignCreated: "Mensagem Criada!",
        messagesQueued: "mensagens na fila",
        scheduledFor: "Agendado para",
        tip: "Dica",

        // Follow-up reminders step
        followUpRemindersTitle: "Lembretes de Acompanhamento",
        followUpRemindersDesc: "Agende lembretes automáticos para seus convidados",
        saveAndResubmitWhatsApp: "Salvar e reenviar ao WhatsApp",
        saveAndResend: "Salvar e reenviar",
        saveAndResubmitHint: "Envia sua mensagem editada de novo ao WhatsApp para aprovação. Depois, ela vai para os convidados que nunca a receberam.",
        saveAndResendHint: "Salva sua mensagem editada e a envia aos convidados que nunca a receberam.",
        // Edit & Resend feedback: the save is instant, the WhatsApp
        // re-submission is not, so they are reported separately (task #592).
        editSavedChanges: "Alterações salvas.",
        editSavedResubmitting: "Alterações salvas. Enviando sua mensagem ao WhatsApp para aprovação…",
        translationStale: "Sua mensagem mudou depois desta tradução. Atualize a tradução.",
        translateAgain: "Traduzir novamente",
        translationStaleBlocked: "Você alterou sua mensagem depois de traduzi-la. Atualize a tradução para {lang} antes de enviar: clique em Traduzir novamente ou edite-a manualmente.",
        translationStaleWarn: "Você alterou sua mensagem depois de traduzi-la. Confirme que a tradução para {lang} ainda corresponde.",
        editSavedRescheduled: "Alterações salvas. Sua mensagem será enviada em {date}.",
        editTimingUseSend: "Alterações salvas. Sua mensagem continua agendada para {date}. Para enviá-la agora, clique em Enviar.",
        editSavedNotSent: "Alterações salvas. Nada foi enviado ainda. Para enviá-la, abra Editar e reenviar e clique em Enviar.",
        editSavedRescheduledPaused: "Alterações salvas. O novo horário é {date}. A mensagem fica pausada até você retomá-la.",
        editTimingAfterReminder: "Há um lembrete desta mensagem agendado para {date}. Escolha uma hora anterior ou altere primeiro o lembrete.",
        editTimingPast: "Essa hora já passou. Escolha uma hora futura.",
        editTimingPickDate: "Escolha uma data e hora para o envio agendado.",
        editResubmitAccepted: "Sua mensagem editada está no WhatsApp aguardando aprovação. Será enviada assim que for aprovada.",
        editResubmitRefused: "O WhatsApp não aceitou a mensagem",
        sendTestSavedAsDraft: "Sua mensagem foi salva como rascunho para podermos enviar este teste — ela está na sua lista de mensagens.",
        editBlockedSending: "Suas alterações não foram salvas: o envio desta mensagem já começou. Quando terminar, adicione os novos convidados com “Adicionar contatos” no cartão dela.",
        editBlockedStale: "Suas alterações não foram salvas: esta mensagem foi alterada enquanto você a editava (por exemplo, foram adicionados convidados ou foi enviada). Feche esta janela e abra-a de novo para editar a versão mais recente.",
        nextFollowUp: "Próximo: Acompanhamento",
        addAnotherReminder: "Adicionar um Lembrete",
        removeReminder: "Remover",
        reminderNumber: "Lembrete",
        whenToSend: "Quando enviar",
        sendTo: "Para quem enviar",
        reminderMessage: "Mensagem",
        reminderButtonsLabel: "Botões",
        reminderButtonRsvp: "Confirmação de presença",
        reminderRsvpAutoIncluded: "(link incluído automaticamente)",
        reminderButtonRegistry: "Lista de presentes",
        reminderButtonDirections: "Como chegar",
        reminderButtonWebsite: "Site do casamento",
        reminderButtonsHint: "Os botões são opcionais — adicione até 2 ou deixe tudo desmarcado para enviar um lembrete em texto simples.",
        reminderButtonLabelLangHint: "Se você deixar em branco, cada botão aparece nos dois idiomas, como mostrado. Um texto que você digitar é enviado exatamente como escrito — escreva os dois idiomas se quiser ambos.",
        reminderEditButton: "Editar",
        reminderEditTitle: "Editar lembrete",
        reminderNewTitle: "Novo lembrete",
        reminderLinkedNote: "Enviado como lembrete vinculado a \"{name}\" — não como uma nova mensagem.",
        reminderRecipientsFinalized: "Os destinatários são definidos quando o lembrete é enviado.",
        reminderFixedRecipientsNote: "Este lembrete será enviado aos {count} destinatários que você selecionou.",
        reminderAudienceScopeNote: "Este acompanhamento será enviado <strong>apenas</strong> aos destinatários desta mensagem específica, não a todos os convidados do seu evento.",
        reminderSendNowHint: "O padrão é agora — será enviado em breve (assim que o WhatsApp aprovar a mensagem). Escolha uma data e hora posteriores para agendar.",
        reminderCancel: "Cancelar",
        reminderSaveChanges: "Salvar alterações",
        reminderCreateBtn: "Criar lembrete",
        reminderReviewContinue: "Continuar",
        reminderReviewPreviewNote: "Quem você remover aqui fica de fora apenas deste lembrete; seus outros lembretes não são afetados. O resto da lista é definido no momento do envio — por exemplo, os convidados que responderem antes disso são ignorados automaticamente.",
        removeButton: "Remover",
        linkChipUrlLabel: "Link",
        linkChipLabelLabel: "Texto do botão",
        linkChipSave: "Adicionar",
        linkChipUrlRequired: "Adicione um link ou cancele.",
        remindAllTitle: "Enviar um lembrete",
        remindAllSubtitle: "{n} destinatários",
        remindAllPreConfigure: "No momento, nenhum convidado corresponde: este lembrete será enviado automaticamente a quem corresponder no momento do envio.",
        remindAllSendingTo: "Enviando para <strong>{n}</strong> convidado(s) selecionado(s).",
        remindAllAddedOptedOut: "Os lembretes estão desativados para {n} dos convidados que você adicionou, por isso eles não vão receber este.",
        remindAllContinue: "Continuar para o envio",
        remindAllNextStepHint: "Você escolherá como enviar e confirmará o custo na próxima etapa.",
        reminderUpdatedToast: "Lembrete atualizado",
        reminderResubmittedToast: "Lembrete atualizado e reenviado ao WhatsApp para aprovação.",
        reminderCreatedToast: "Lembrete criado — será enviado no horário agendado.",
        reminderSendingNowToast: "Seu lembrete está a caminho — sendo enviado agora.",
        reminderUpdateFailed: "Falha ao atualizar o lembrete: ",
        reminderCreateFailed: "Falha ao criar o lembrete: ",
        reminderAlertPickDateTime: "Escolha uma data e hora de envio.",
        reminderAlertTrailingTag: "Sua mensagem não pode terminar com uma etiqueta de personalização como {{table_number}} — o WhatsApp não permite. Adicione algumas palavras depois (ex.: \"Até lá!\").",
        reminderAlertValidDateTime: "Insira uma data e hora válidas.",
        reminderAlertRegistryUrl: "Adicione um URL para o link da lista de presentes ou desmarque-o.",
        reminderAlertDirectionsUrl: "Adicione um URL para o link de como chegar ou desmarque-o.",
        reminderAlertWebsiteUrl: "Adicione um URL para o link do site do casamento ou desmarque-o.",
        reminderAlertLivestreamUrl: "Adicione um link para a transmissão ao vivo ou desmarque-a.",
        reminderSendNowChoice: "Enviar agora",
        reminderScheduleChoice: "Agendar para depois",
        reminderGoesOutShortly: "Seu lembrete sairá em breve (assim que o WhatsApp aprovar a mensagem).",
        reminderHourOnlyHint: "Os lembretes são enviados na hora cheia (os minutos não são usados).",
        reminderIncludeImage: "Incluir a foto do convite",
        reminderImageHeading: "Imagem",
        reminderTranslateLabel: "Também enviar uma tradução em {lang}",
        reminderTranslateHint: "Desativado por padrão — seu lembrete é enviado exatamente como escrito. Ative para traduzir e anexar automaticamente.",
        useDifferentLink: "Usar outro link…",
        reminderIncludeThisImage: "Incluir esta imagem",
        reminderUseDifferentImage: "Usar outra imagem",
        reminderCustomImageNote: "Este lembrete usa uma imagem diferente da do convite.",
        reminderButtonsMax: "Você pode incluir até 2 botões por lembrete.",
        reminderButtonUrlPlaceholder: "Cole um link (https://...)",
        invalidButtonUrlWarning: "Isso não parece um link válido. Se for um endereço, cole o link do Google Maps — links inválidos são omitidos nas mensagens de WhatsApp.",
        reminderDirectionsUrlPlaceholder: "Link do Google Maps ou Waze",
        reminderButtonUrlMissing: "Adicione um link para o botão selecionado ou desmarque-o.",
        resetToDefault: "Restaurar padrão",
        guestsWhoHaventRSVPd: "Convidados que não confirmaram",
        attendingGuests: "Convidados confirmados",
        allGuests: "Todos os convidados",
        guestsAnsweredMaybe: "Convidados que responderam “Talvez”",
        guestsDeclined: "Convidados que responderam “Não”",
        twoWeeksBefore: "2 semanas antes do evento",
        oneWeekBefore: "1 semana antes do evento",
        threeDaysBefore: "3 dias antes do evento",
        oneDayBefore: "1 dia antes do evento",
        dayOfEvent: "No dia do evento",
        oneDayAfter: "No dia seguinte ao evento",
        threeDaysAfter: "3 dias após o evento",
        reminderButtonAlbum: "Álbum de fotos dos convidados",
        reminderButtonLivestream: "Transmissão ao vivo",
        reminderLivestreamUrlPlaceholder: "Link do YouTube, Zoom ou Facebook Live",
        reminderAlbumOff: "Ative o álbum na aba “Fotos dos convidados” para obter o link.",
        customDate: "Data personalizada",
        pickReminderDate: "Escolha uma data",
        reminderTime: "Horário",
        reminderTimeHint: "Enviado neste horário, no seu fuso horário local.",
        guestNightWarning: "Atenção: muitos dos seus convidados vão receber isto à noite (por volta das {time}, na hora deles). O envio é feito no horário que você escolheu, mas durante o dia as respostas costumam chegar mais rápido.",
        reminderTimePast: "Escolha uma data e um horário futuros para o seu lembrete personalizado",
        reminderDateInvalid: "A data do lembrete deve ser no dia ou antes da data do evento",
        reminderDateMissing: "Por favor, escolha uma data para o seu lembrete personalizado",
        reminderNoEventDate: "Seu evento ainda não tem data, então um lembrete só pode ser enviado em uma data que você escolher. Escolha \"Data personalizada\" ou adicione a data do evento no editor para programar os lembretes a partir dela.",
        reminderAfterRsvpDeadline: "As respostas fecham antes do horário deste lembrete, então ele não será enviado. Altere o prazo de resposta no editor, escolha um horário mais cedo ou remova o link de confirmação.",
        defaultReminderMessage: "Olá! Apenas um lembrete amigável — adoraríamos ouvir de você! Por favor, confirme sua presença quando puder.",
        defaultAttendingMessage: "Estamos ansiosos para vê-lo! Aqui está um lembrete rápido sobre os detalhes do evento.",
        defaultMaybeMessage: "Olá! Você disse que talvez pudesse vir — já decidiu? Adoraríamos uma resposta final, sim ou não, para podermos nos organizar. Por favor, atualize sua confirmação quando puder.",
        creditsChargedNote: "Os créditos são cobrados quando cada lembrete é realmente enviado. Certifique-se de ter créditos suficientes no momento.",
        skipFollowUpNote: "Você pode pular esta etapa e enviar acompanhamentos depois criando uma nova mensagem no seu painel.",
        remindersConfigured: "lembrete(s) agendado(s)",

        // Toast messages - Payment
        paymentSuccessClickMessage: "Pagamento bem-sucedido! Clique em 'Enviar aos convidados' para continuar.",
        paymentSuccessSendReady: "Pagamento bem-sucedido! Agora você pode enviar sua mensagem.",
        paymentSuccessClickContinue: "Pagamento bem-sucedido! Clique em 'Enviar aos convidados' para continuar.",
        paymentSuccessGeneric: "Pagamento bem-sucedido!",
        paymentProcessingWait: "Aguarde enquanto sua solicitação é processada...",
        paymentSystemUnavailable: "Sistema de pagamento indisponível. Atualize e tente novamente.",
        paymentCompletedReady: "Pagamento concluído! Sua mensagem está pronta para enviar.",
        paymentSuccessEmoji: "🎉 Pagamento bem-sucedido! Agora você pode enviar sua mensagem.",
        cannotSaveDraftNoEvent: "Não é possível salvar rascunho: nenhum evento selecionado",
        pleaseLoginToSaveDrafts: "Faça login para salvar rascunhos",
        failedToSaveDraft: "Falha ao salvar rascunho. Tente novamente.",
        campaignSentSuccess: "🎉 Mensagem enviada! {count} créditos utilizados.",
        insufficientCredits: "Créditos insuficientes. Compre mais créditos para enviar sua mensagem.",
        errorProcessingCampaign: "Erro ao processar mensagem. Tente novamente.",
        campaignSubmitted: "Mensagem enviada! As mensagens serão enviadas automaticamente.",
        campaignScheduledFor: "Mensagem agendada! As mensagens serão enviadas em {date}.",
        failedToSchedule: "Falha ao agendar mensagem. Entre em contato com o suporte.",
        verifyEmailBeforeSending: "Confirme seu e-mail antes de enviar — digite o código na aba Compartilhar do editor do formulário e depois envie. Seu link já funciona para os convidados. Nada foi enviado nem cobrado.",
        translationComplete: "Tradução concluída!",
        translationFailed: "A tradução falhou. Tente novamente.",
        translationFailedManual: "A tradução falhou. Insira a tradução manualmente.",
        messageTranslatedTo: "Mensagem traduzida para {language}!",
        translationFailedRetry: "A tradução falhou. Tente novamente ou insira a mensagem manualmente.",
        pleaseWriteMessageFirst: "Por favor, escreva uma mensagem primeiro",
        loadFromContacts: "Meus Contatos",
        noSavedContacts: "Ainda não há contatos salvos. Os contatos para quem você envia mensagens em uma campanha são salvos automaticamente na sua lista de endereços.",
        addressBook: "Lista de Endereços",
        addContact: "Adicionar Contato",
        deleteContactConfirm: "Excluir este contato da sua lista de endereços?",
        edit: "Editar",
        delete: "Excluir",
        save: "Salvar",
        contactNeedsInfo: "Um contato precisa de um nome e um e-mail ou telefone.",
        importFromPhone: "Importar do Telefone",
        importFromPhoneCancelled: "Nenhum contato selecionado.",
        importFromPhoneFailed: "Falha ao importar contatos: ",
        importFromGoogle: "Importar do Google Contatos",
        noGoogleContactsFound: "Nenhum contato encontrado em sua conta Google.",
        googleContactsFailed: "Falha ao carregar Google Contatos: ",
        importFromResponses: "Usar minha lista de convidados",
        importFromResponsesTitle: "Importar da sua lista de convidados",
        importFromResponsesSubtitle: "Todos da lista de convidados deste evento: quem já respondeu e quem você adicionou e ainda não respondeu. Só é possível enviar mensagens para quem tem telefone ou e-mail.",
        noRespondersFound: "Sua lista de convidados está vazia: não há ninguém para importar.",
        noReachableResponders: "Ninguém na sua lista de convidados tem telefone ou e-mail, então não há ninguém para enviar mensagens aqui.",
        respondersFailed: "Não foi possível carregar sua lista de convidados: ",
        respondersUnreachableNote: "Mais {count} pessoa(s) da sua lista não têm telefone nem e-mail e não podem receber mensagens.",
        respondersAlreadyAdded: "Já está na sua lista",
        rsvpStatusColumn: "Resposta",
        rsvpFilterAll: "Todos",
        rsvpFilterYes: "Vão comparecer",
        rsvpFilterMaybe: "Talvez",
        rsvpFilterNo: "Não vão",
        rsvpFilterWaitlisted: "Lista de espera",
        rsvpFilterPending: "Sem resposta",
        rsvpStatusYes: "Sim",
        rsvpStatusMaybe: "Talvez",
        rsvpStatusNo: "Não",
        rsvpStatusWaitlisted: "Lista de espera",
        rsvpStatusPending: "Sem resposta",
        addMoreContacts: "Adicionar mais contatos",
        exportCsv: "Exportar CSV",
        status: "Status",
        tags: "Etiquetas",
        allTags: "Todas as etiquetas",
        replaceFile: "Substituir arquivo",
        maxGuestsCol: "Máx. convidados",
        maxGuestsColHint: "Número máximo de convidados que este convite pode levar (deixe em branco para usar o limite padrão do formulário)",
        // The guest-list columns (task #935)
        guestNamesCol: "Nome(s) dos convidados",
        guestNamesColHint: "Como adicionar nomes de convidados\n• Separe os nomes com ponto e vírgula (;). Vírgulas também funcionam.\n• Acrescente (criança) após o nome de uma criança, p. ex. Pedro Silva (criança).\n• Exemplo: Ana Silva; João Silva; Pedro Silva (criança)\n• O telefone e o e-mail da linha são da primeira pessoa da lista.",
        guestNamesPh: "Sara Silva; Miguel Silva",
        groupNameCol: "Nome do grupo",
        groupNameColHint: "A quem o convite é dirigido, p. ex. Família Silva. Aparece no envelope e nas boas-vindas do formulário; as mensagens saúdam os nomes dos convidados (“Olá Ana & Pedro”).\nDeixe em branco para um convidado que vem sozinho. Se você preencher só o nome do grupo, os convidados encontram o convite por ele e digitam os seus nomes; com nomes de convidados, cada um o encontra pelo próprio nome.",
        groupNamePh: "Família Silva",
        contactPreviewTitle: "Como este convite aparece",
        contactPreviewEnvelope: "Endereçado a",
        contactPreviewGreetingLine: "Olá, {name}",
        contactPreviewLookup: "Digitar qualquer um destes encontra este convite:",
        contactPreviewNoLookup: "Adicione um sobrenome ou um nome de grupo para que este convidado encontre o convite pelo nome.",
        contactPreviewAsksNames: "Ainda sem nomes: quem encontrar o convite informará os nomes do seu grupo.",
        diffSurnamesTip: "Dica: adicione telefones, e-mails ou nomes completos para cada membro do grupo, para que qualquer pessoa do grupo encontre facilmente a sua resposta.",
        sameNameWarning: "Atenção: você tem vários convidados ou grupos com o mesmo nome. Adicione um e-mail ou um telefone para cada um, para que possam confirmar a identidade ao procurar o convite.",
        lastFirstFlag: "Uma pessoa, com o sobrenome primeiro? Separe pessoas diferentes com “;”.",
        prefillNameLabel: "Preencher o nome de cada convidado no formulário",
        prefillNameDesc: "Cada link pessoal abre com o nome do contato já preenchido no campo de nome (e no envelope, se essa opção estiver ativada). Desative se sua lista tiver apelidos ou números compartilhados: os convidados digitam o próprio nome; os limites de convidados continuam valendo.",
        contactsSelected: "contato(s) selecionado(s)",
        addSelected: "Adicionar selecionados",
        selectAll: "Selecionar Todos",
        importedContactsSummary: "{added} contato(s) importado(s). {skipped} ignorado(s) como duplicado(s).",
        noOrgFound: "Nenhuma organização encontrada. Configure sua organização primeiro.",
        noOrgContacts: "Nenhum contato encontrado em sua organização. Adicione contatos primeiro.",
        failedToLoadContacts: "Falha ao carregar contatos: ",
        selectAtLeastOneContact: "Selecione pelo menos um contato.",
        contactsClearedMessage: "Contatos removidos. Agora você pode enviar uma nova lista.",
        unsavedContactsWarning: "Você tem contatos não salvos. Pressione Cancelar para voltar e salvar, ou OK para descartar.",
        unsupportedFileType: "Tipo de arquivo não suportado. Envie um arquivo CSV (.csv) ou vCard (.vcf).",
        fileAlreadyUploaded: "O arquivo \"{filename}\" já foi enviado.",
        fileReplaced: "Substituímos os {replaced} contato(s) de \"{filename}\" pelos {count} do arquivo que você acabou de enviar.",
        fileMergedSummary: "{added} contato(s) adicionado(s) de \"{filename}\"; {updated} que já estavam na sua lista foram atualizados com os dados do arquivo.",
        failedToProcessFile: "Falha ao processar arquivo. Verifique o formato e tente novamente.",
        noContactsInFile: "Lemos \"{filename}\" mas não encontramos nenhum contato nele.\n\nColunas encontradas: {headers}\n\nCada contato precisa de um e-mail ou telefone, sob um cabeçalho que reconhecemos — por exemplo \"name\", \"email\", \"phone\". Renomeie os cabeçalhos na sua planilha e envie novamente.",
        encodingDamageWarning: "Parece que \"{filename}\" perdeu os caracteres não ingleses: os nomes aparecem como \"???\" ou com texto ilegível.\n\nIsso costuma acontecer quando o Excel em um Mac salva um arquivo .csv comum. O texto original já não está no arquivo, então importá-lo criaria contatos com nomes ilegíveis.\n\nPara corrigir: no Excel escolha Arquivo → Salvar como → \"CSV UTF-8 (delimitado por vírgulas)\" e envie novamente. O Google Sheets e o Numbers exportam arquivos corretos automaticamente.\n\nImportar mesmo assim?",
        processingFile: "Processando {filename}...",
        missingNamesWarning: "{count} contato(s) não têm nome — aparecerão como \"Desconhecido\". Adicione-os na lista abaixo.",
        // Household invitations (task #908)
        householdCouplesSuggest: "{count} convite(s) citam mais de uma pessoa, p. ex. “{example}”. Contar todos os citados, com os nomes já preenchidos no formulário?",
        householdCouplesYes: "Sim, contar",
        householdNoThanks: "Não, obrigado",
        householdFamiliesNote: "{count} convite(s) são para uma família, p. ex. “{example}”. Adicione quem vem em {members} (ou defina {maxGuests}) para que o formulário preencha os nomes e conte certo.",
        loadingText: "Carregando...",
        verifyingPayment: "Verificando status do pagamento...",
        pleaseWaitVerify: "Aguarde enquanto confirmamos sua atualização",
        paymentVerified: "Pagamento verificado!",
        paymentProcessing: "Processando pagamento",
        errorVerifyingPayment: "Erro ao verificar pagamento",
        validLabel: "Válido",
        checkLabel: "Verificar",
        toCheck: "para verificar",
        phoneCheckChargedNote: "enviado e cobrado do jeito que está se você não corrigir",
        phoneWarnDoubledCc: "o código do país aparece duas vezes",
        phoneWarnCc927: "927 não é um código de país — quis dizer +972?",
        phoneWarnNanpArea: "em um número +1, o código de área não pode começar com 0 ou 1",
        phoneWarnNanpNoCc: "se for um número dos EUA ou do Canadá, precisa do +1: {suggest}",
        phoneWarnLength: "um número de celular +{cc} tem {want} dígitos depois do código do país; este tem {got}",
        phoneWarnUkPrefix: "um número de celular +44 começa com 7",
        phoneWarnIlPrefix: "um número de celular +972 começa com 5",
        phoneWarnAssumed: "sem código do país — lido como {country} ({number}); altere se estiver errado",
        phoneWarnNeedsCountry: "sem código do país — adicione-o no início, por exemplo +55",
        phoneWarnInvalid: "não é um número válido ({country}) — verifique os dígitos",
        phoneWarnInvalidAny: "não é um número de telefone válido — verifique os dígitos",
        phoneWarnLandline: "é um telefone fixo ({country}) — não pode receber WhatsApp nem SMS",
        phoneCountryLabel: "Os números sem código do país são lidos como",
        phoneCountryHint: "A maioria dos números da sua lista é de {country}.",
        phoneCountryUse: "Usar {country}",
        contactsLoaded: "Contatos carregados",
        countryUnknown: "Desconhecido",
        rowLabel: "Linha",
        deliveryDisclaimer: "A entrega nunca é de 100%. Uma pequena parte das mensagens pode ficar retida pelos limites de marketing da Meta, filtros das operadoras, pastas de spam ou contatos inválidos — é normal em qualquer plataforma de mensagens.",
        tagsCol: "Etiquetas",
        tagsColHint: "Em que grupo está este convidado, por ex. família, só recepção. Separe as etiquetas com vírgulas.\nSe uma parte do evento estiver limitada a certas etiquetas (definido no editor, em Partes do evento), o link pessoal deste convidado mostra apenas as partes que correspondem às suas etiquetas.",
        campaignNameDupAddInstead: "Clique aqui para adicionar os contatos agora à sua mensagem existente",
        campaignNameDupAddInsteadSuffix: "em vez disso",
        progressChecklistTitle: "Seu progresso",
        checkCampaignName: "Nome da mensagem",
        checkAddContacts: "Adicionar contatos",
        checkCustomizeMessage: "Personalizar mensagem",
        checkConfigureFollowUp: "Configurar acompanhamento",
        checkSendInvitations: "Enviar convites",
        contactsSummaryTitle: "Resumo dos contatos",
        totalGuestsAdded: "Total de convidados adicionados",
        contactsImported: "Contatos importados",
        needsAttention: "Requer atenção",
        supportedImportMethods: "Formas de importar",
        manualEntry: "Entrada manual",
        headerOptional: "(Opcional)",
        renameTooltip: "Renomear",
        gateNoRecipients: "Adicione pelo menos um destinatário antes de seguir para o envio.",
        gateNoMessage: "Escreva sua mensagem antes de seguir para o envio.",
        gateGoToStep: "Ir para a etapa {n}",
        sendStalled: "A conexão com nossos servidores falhou antes de sua mensagem ser salva — nada foi enviado e nenhum crédito foi usado. Recarregue esta página, abra a mensagem de novo e clique em Enviar.",
        loadingSites: "Carregando seus sites de casamento…",
        noWeddingSites: "Nenhum site de casamento encontrado.",
        createWeddingSite: "Criar um",
        usingSite: "Usando",
        chooseSite: "Escolha um site de casamento…",
        siteNotPublished: "publique para usar",
        noPublishedSite: "Nenhum dos seus sites de casamento está publicado — publique um para que os convidados possam confirmar presença.",
        rsvpEnabledHint: "Confirme que a página de RSVP do seu site está ativada para que os convidados possam responder.",
        loadingFollowUp: "Carregando a mensagem de acompanhamento...",
        loadingDraft: "Carregando o rascunho...",
        creditsAlreadyEnough: "Você já tem créditos suficientes para esta mensagem — revise-a e clique em Enviar.",
        remindersSkippedBeforeSend: "{count} lembrete(s) não agendado(s) — a hora deles é anterior ao envio desta mensagem.",
        invalidLabel: "Inválido",
        verifyCountryCode: "⚠ Verifique o código do país",
        enterGuestName: "Digite o nome do convidado",
        emailPlaceholder: "nome@exemplo.com",
        phonePlaceholder: "+5511912345678",
        validContacts: "Contatos válidos",
        scheduledTimePast: "O horário agendado não pode ser no passado",
        recipientsLabel: "Destinatários",
        noNameLabel: "(sem nome)",
        removeRecipient: "Remover",
        removeThisContact: "Remover este contato",
        allRecipientsRemoved: "Você removeu todos os destinatários. Adicione alguns para poder enviar.",
        sendNoFormSelected: "Não há nenhum formulário selecionado para esta mensagem. Abra primeiro um formulário salvo e tente enviar novamente.",
        sendFormNotSaved: "Seu formulário ainda não terminou de ser salvo. Abra-o de novo no editor, salve-o e tente enviar novamente.",
        draftSavedFindOnDashboard: "Rascunho salvo. Ele está em Mensagens, no seu painel.",
        processingButton: "Processando...",
        personalize: "Personalizar:",
        demoLabel: "demo",
        searchContactsPlaceholder: "Buscar por nome, email ou telefone...",
        loading: "Carregando...",

        // New wizard keys
        fullNamePlus: "+ Nome Completo",
        firstNamePlus: "+ Primeiro Nome",
        emailPlus: "+ Email",
        tableNumberPlus: "+ Número da Mesa",
        tableTagDisabledHint: "Configure o mapa de mesas integrado para personalizar com o número da mesa de cada convidado.",
        tableExampleInput: "Sua mesa é a {{table_number}}",
        tableSplitNoticeOne: "1 grupo está sentado em mais de uma mesa sem o nome de cada convidado, então a linha da mesa vai aparecer como \"Dana 2, Dana 3\". Adicione o nome de cada convidado na lista de convidados para ficar claro.",
        tableSplitNoticeMany: "{count} grupos estão sentados em mais de uma mesa sem o nome de cada convidado, então a linha da mesa vai aparecer como \"Dana 2, Dana 3\". Adicione o nome de cada convidado na lista de convidados para ficar claro.",
        clickToInsert: "Clique para inserir — cada convidado recebe sua versão personalizada.",
        seeExample: "Ver exemplo",
        hideExample: "Ocultar exemplo",
        youWrite: "Você escreve:",
        exampleInput: "Olá {{first_name}}, você está convidado para o nosso evento!",
        eachGuestGets: "Cada convidado recebe:",
        sendTestEmailToMe: "Enviar primeiro um e-mail de teste para mim",
        testEmailSending: "Enviando e-mail de teste…",
        testEmailSent: "E-mail de teste enviado para {email}",
        testEmailFailed: "Não foi possível enviar o e-mail de teste",
        sendTestTitle: "Envie um teste para você",
        sendTestSubtitle: "Receba uma cópia real no seu próprio celular e e-mail, exatamente como os convidados verão.",
        sendTestBtn: "Enviar teste",
        sendTestCostNote: "O primeiro teste desta mensagem é gratuito. Depois, cada teste por SMS ou WhatsApp usa 1 crédito — testes por e-mail são sempre gratuitos.",
        sendTestCostAfterFree: "Seu teste gratuito desta mensagem já foi usado. Cada teste adicional por SMS ou WhatsApp usa 1 crédito — testes por e-mail continuam gratuitos.",
        sendTestPhoneLabel: "Número de celular para o teste",
        sendTestPhoneHint: "Sua conta não tem número de celular, então informe um para receber o teste. Vamos lembrar dele.",
        sendTestPhoneInvalid: "Isso não parece um número de celular. Use o formato internacional, por exemplo +14155550123.",
        sendTestSending: "Enviando seu teste…",
        sendTestDone: "Teste enviado para você",
        sendTestEmailCopyOnly: "O e-mail é uma cópia só para você — seus convidados não receberão e-mail.",
        sendTestFailed: "Não foi possível enviar o teste",
        sendTestCreditReturned: "O crédito deste teste foi devolvido ao seu saldo.",
        sendTestEmptyMessage: "Escreva sua mensagem primeiro — ainda não há nada para testar.",
        sendTestRoutedToWhatsApp: "Número fora dos EUA, por isso este teste usa o WhatsApp.",
        // A test parked waiting for Meta, and every way that wait can end (task #604).
        sendTestQueued: "Seu teste está na fila. O WhatsApp ainda está aprovando sua mensagem — o teste será enviado sozinho assim que for aprovado, então não há mais nada a fazer aqui.",
        sendTestQueuedSent: "Aprovado — seu teste acaba de ser enviado para o seu WhatsApp.",
        sendTestQueuedFailed: "O WhatsApp aprovou sua mensagem, mas o teste não pôde ser enviado. Toque em Enviar teste para tentar novamente.",
        sendTestQueuedNoCredits: "O WhatsApp aprovou sua mensagem, mas o teste na fila precisava de um crédito e não havia nenhum disponível. Recarregue e toque em Enviar teste novamente.",
        sendTestQueuedExpired: "Seu teste na fila expirou antes de o WhatsApp aprovar a mensagem. Toque em Enviar teste novamente para enviar um agora.",
        // What the status webhook later says about an accepted WhatsApp test.
        sendTestDelivered: "Entregue no seu WhatsApp ✓",
        sendTestNotDelivered: "O teste de WhatsApp não foi entregue",
        sendTestMetaLimit: "O WhatsApp não entregou este teste: a Meta limita quantas mensagens de marketing um mesmo número pode receber, e testes repetidos podem atingir esse limite no seu próprio número. Sua campanha e seus convidados NÃO são afetados — você pode enviar sem medo. Para testar de novo agora, envie uma mensagem qualquer (nem que seja “oi”) para o número de WhatsApp de onde veio o seu teste anterior e tente outra vez — o limite não se aplica dentro de uma conversa aberta. Caso contrário, aguarde algumas horas.",
        includeRsvpLink: "Incluir link de confirmação na mensagem",
        rsvpLinkDisabledDesc: "Quando desativado, a mensagem é enviada sem link para o formulário de confirmação.",
        includeQrCode: "Incluir código QR de check-in",
        qrCodeDesc: "Convidados que confirmaram receberão seu código QR pessoal.",
        qrCodeWhatsappNote: "No WhatsApp, o código QR substituirá a imagem da mensagem.",
        finalCampaignSummary: "Resumo Final da Mensagem",
        messagesToSend: "Mensagens a Enviar",
        creditsUsed: "Créditos Usados",
        clickingScheduleNote: "Ao clicar em \"Agendar e Enviar\", suas mensagens serão enfileiradas.",
        scheduleAndSend: "Agendar e Enviar",
        canStillGoBack: "Você ainda pode voltar e fazer alterações antes de enviar.",
        campaignSentSuccessfully: "Mensagem enviada com sucesso!",
        messagesBeingDelivered: "Suas {count} mensagens estão sendo entregues agora.",
        windowWillClose: "Esta janela fechará automaticamente...",
        closeButton: "Fechar",
        smsConsentAgree: "Eu concordo com os",
        andText: "e",
        buyMessageCredits: "Comprar Créditos",
        campaignRequires: "Mensagem requer:",
        yourBalanceLabel: "Seu saldo:",
        needLabel: "Precisa:",
        selectPackage: "Selecione um pacote:",
        bestValue: "Melhor Valor",
        calcHelper: "Quantos créditos preciso?",
        freeShareBalance: "Você tem {n} créditos de mensagens (todas as contas começam com 25 grátis), e sua primeira mensagem de teste também é grátis.",
        freeShareLead: "Prefere enviar do seu celular ou e-mail? Sem usar créditos:",
        freeShareCopy: "Copiar link",
        freeSharePersonal: "Links pessoais",
        freeShareCopied: "Link copiado",
        calcGuests: "convidados",
        calcMsgs: "mensagens cada",
        calcCadence: "A maioria dos anfitriões envia 3 mensagens por convidado: convite, lembrete e aviso do dia. Os lembretes geralmente vão apenas para quem não respondeu, então o uso real costuma ser menor.",
        creditsAmount: "{count} créditos",
        creditsMoreAmount: "mais {count} créditos",
        creditsUnit: "créditos",
        packEnoughForSend: "Suficiente para esta mensagem",
        packNeedMore: "Faltam {count}",
        creditsNeverExpireNote: "Os créditos nunca expiram • Use-os em todos os formulários",
        haveEnoughCredits: "Você tem créditos suficientes!",
        creditsAvailableNeeded: "{balance} créditos disponíveis (são necessários {needed})",
        selectCreditPackage: "Escolha um pacote de créditos",
        purchaseStartFailed: "Não foi possível iniciar a compra. Tente novamente.",
        previewNotInteractive: "Visualização — não interativa",
        emailTab: "Email",
        whatsappTab: "WhatsApp",
        smsTab: "SMS",
        translating: "Traduzindo...",
        otherLanguage: "Outro Idioma",
        campaignSubmittedSuccessfully: "Mensagem enviada com sucesso!",
        submittingCampaign: "Enviando mensagem...",
        submissionFailed: "Falha no envio",
        submitting: "Enviando...",
        errorDetails: "Detalhes do erro:",
        missingEmailAndPhone: "Email e telefone ausentes",
        invalidEmailFormat: "Formato de email inválido",
        invalidPhoneFormat: "Formato de telefone inválido",
        paymentSuccessful: "Pagamento realizado com sucesso!",
        unknownError: "Erro desconhecido",
        removeImage: "Remover imagem",
        pendingTranslation: "Tradução pendente",
        removeLanguage: "Remover idioma",
        notSpecified: "Não especificado",
    }
};

// Register with dashboard language system if available
if (window.DashboardLanguageSystem) {
    window.DashboardLanguageSystem.registerLanguageContent('pt', window.PortugueseDashboardContent);
}
